import { Button, Col, Row } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import "./styles.css";

function CategoriesList(props) {
  const { editModal } = props;
  const { categories } = useSelector((state) => state.categoryReducer);

  return (
    <div>
      <Row className="home_head_table">
        <Col xl={1} className="h-auto">
          <div className="home_head_table_cell">Ordre</div>
        </Col>
        <Col xl={7} className="h-auto">
          <div className="home_head_table_cell">Nom</div>
        </Col>
        <Col xl={4} className="h-auto">
          <div className="home_head_table_cell">Raccourci</div>
        </Col>
        <Col xl={2} className="h-auto">
          <div className="home_head_table_cell">Image</div>
        </Col>
        <Col xl={5} className="h-auto">
          <div className="home_head_table_cell">URL</div>
        </Col>
        <Col xl={3} className="h-auto">
          <div className="home_head_table_cell">Active</div>
        </Col>
        <Col xl={2} className="h-auto">
          <div className="px5 py10 h-full">Action</div>
        </Col>
      </Row>
      {categories.map((category) => (
        <Row key={category._id} className="home_body_table">
          <Col xs={2} xl={1} className="h-auto">
            <div className="home_head_table_cell home_body_table_text_left text-center">
              {category.order}
            </div>
          </Col>
          <Col xs={22} xl={7} className="h-auto">
            <div className="home_head_table_cell home_body_table_text_right home_body_table_title">
              {category.name}
            </div>
          </Col>
          <Col xs={11} xl={4} className="h-auto">
            <div className="home_head_table_cell home_body_table_text_left">
              {category.short}
            </div>
          </Col>
          <Col xs={13} xl={2} className="h-auto">
            <div className="home_head_table_cell home_body_table_text_right">
              <img
                src={category.categoryImage}
                alt="preview logo"
                className="category_image_list"
              />
            </div>
          </Col>
          <Col xs={11} xl={5} className="h-auto">
            <div className="home_head_table_cell home_body_table_text_left">
              {category.url}
            </div>
          </Col>
          <Col xs={13} xl={3} className="h-auto">
            <div className="home_head_table_cell home_body_table_text_left">
              {category.active ? (
                <div className="active-item">Active</div>
              ) : (
                <div className="inactive-item">Inactive</div>
              )}
            </div>
          </Col>
          <Col xs={24} xl={2} className="h-auto">
            <div className="p5 h-full">
              <Button
                className="w-full"
                type="primary"
                onClick={() => editModal(category._id)}
              >
                Modifier
              </Button>
            </div>
          </Col>
        </Row>
      ))}
    </div>
  );
}

export default CategoriesList;
